import {
  BrainCircuit, ChartScatter, CloudCog, CodeXml, Crown, PenTool, Route, Server,
  ServerCog, ShieldCheck, Smartphone, Workflow, Briefcase, type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  BrainCircuit, ChartScatter, CloudCog, CodeXml, Crown, PenTool, Route, Server,
  ServerCog, ShieldCheck, Smartphone, Workflow,
};

export const berufIcon = (name: string): LucideIcon => ICONS[name] ?? Briefcase;
